export const ad_convert = [
  { value: 'OPTIMIZATIONGOAL_FOLLOW', label: '关注' },
  { value: 'OPTIMIZATIONGOAL_CLICK', label: '点击' },
  { value: 'OPTIMIZATIONGOAL_APP_DOWNLOAD', label: '下载' },
  { value: 'OPTIMIZATIONGOAL_APP_ACTIVATE', label: '激活' },
  { value: 'OPTIMIZATIONGOAL_APP_REGISTER', label: '注册' },
  { value: 'OPTIMIZATIONGOAL_ONE_DAY_RETENTION', label: '次日留存' },
  { value: 'OPTIMIZATIONGOAL_PAGE_SCAN_CODE', label: '加企业微信客服' },
  { value: 'OPTIMIZATIONGOAL_CANVAS_CLICK', label: '跳转按钮点击' },
  { value: 'OPTIMIZATIONGOAL_PAGE_RESERVATION', label: '表单预约' }
]

export const ages = [
  { key: 14, label: '14岁' },
  { key: 18, label: '18岁' },
  { key: 19, label: '19岁' },
  { key: 20, label: '20岁' },
  { key: 21, label: '21岁' },
  { key: 22, label: '22岁' },
  { key: 23, label: '23岁' },
  { key: 24, label: '24岁' },
  { key: 25, label: '25岁' },
  { key: 26, label: '26岁' },
  { key: 27, label: '27岁' },
  { key: 28, label: '28岁' },
  { key: 29, label: '29岁' },
  { key: 30, label: '30岁' },
  { key: 31, label: '31岁' },
  { key: 32, label: '32岁' },
  { key: 33, label: '33岁' },
  { key: 34, label: '34岁' },
  { key: 35, label: '35岁' },
  { key: 36, label: '36岁' },
  { key: 37, label: '37岁' },
  { key: 38, label: '38岁' },
  { key: 39, label: '39岁' },
  { key: 40, label: '40岁' },
  { key: 41, label: '41岁' },
  { key: 42, label: '42岁' },
  { key: 43, label: '43岁' },
  { key: 44, label: '44岁' },
  { key: 45, label: '45岁' },
  { key: 46, label: '46岁' },
  { key: 47, label: '47岁' },
  { key: 48, label: '48岁' },
  { key: 49, label: '49岁' },
  { key: 50, label: '50岁' },
  { key: 51, label: '51岁' },
  { key: 52, label: '52岁' },
  { key: 53, label: '53岁' },
  { key: 54, label: '54岁' },
  { key: 55, label: '55岁' },
  { key: 56, label: '56岁' },
  { key: 57, label: '57岁' },
  { key: 58, label: '58岁' },
  { key: 59, label: '59岁' },
  { key: 60, label: '60岁' },
  { key: 61, label: '61岁' },
  { key: 62, label: '62岁' },
  { key: 63, label: '63岁' },
  { key: 64, label: '64岁' },
  { key: 65, label: '65岁' },
  { key: 66, label: '66岁及以上' }
]

export const label_data = [
  {
    id: 1,
    name: '世界观',
    children: [
      {
        id: 11,
        name: 'IP还原'
      },
      {
        id: 12,
        name: '正版授权'
      }
    ]
  },
  {
    id: 2,
    name: '操作体验',
    children: [
      {
        id: 21,
        name: '多线操作'
      },
      {
        id: 22,
        name: '操作流畅'
      },
      {
        id: 23,
        name: '轻松上手'
      },
      {
        id: 24,
        name: '高爆率快节奏'
      }
    ]
  },
  {
    id: 3,
    name: '核心玩法',
    children: [
      {
        id: 31,
        name: 'ARPG'
      },
      {
        id: 32,
        name: 'MMORPG'
      },
      {
        id: 33,
        name: 'MOBA'
      },
      {
        id: 34,
        name: '冒险通关'
      },
      {
        id: 35,
        name: '动作格斗'
      },
      {
        id: 36,
        name: '吃鸡'
      },
      {
        id: 37,
        name: '商业运营'
      },
      {
        id: 38,
        name: '回合制'
      },
      {
        id: 39,
        name: '城市建筑'
      },
      {
        id: 301,
        name: '塔防'
      },
      {
        id: 302,
        name: '对战'
      },
      {
        id: 303,
        name: '恋爱养成'
      },
      {
        id: 304,
        name: '战争'
      },
      {
        id: 305,
        name: '战棋'
      },
      {
        id: 306,
        name: '拟物'
      },
      {
        id: 307,
        name: '挂机'
      },
      {
        id: 308,
        name: '换装'
      },
      {
        id: 309,
        name: '推理解谜'
      },
      {
        id: 310,
        name: '收集养成'
      },
      {
        id: 311,
        name: '放置'
      },
      {
        id: 312,
        name: '枪战射击'
      },
      {
        id: 313,
        name: '横版射击'
      },
      {
        id: 314,
        name: '消除'
      },
      {
        id: 315,
        name: '生存'
      },
      {
        id: 316,
        name: '益智'
      },
      {
        id: 317,
        name: '竞速'
      },
      {
        id: 318,
        name: '综合娱乐'
      },
      {
        id: 319,
        name: '舞蹈'
      },
      {
        id: 320,
        name: '跑酷躲避'
      },
      {
        id: 321,
        name: '载具射击'
      },
      {
        id: 322,
        name: '音乐节奏'
      },
      {
        id: 323,
        name: '飞行射击'
      }
    ]
  },
  {
    id: 4,
    name: '游戏画风',
    children: [
      {
        id: 41,
        name: 'Q萌卡通'
      },
      {
        id: 42,
        name: '中式古典'
      },
      {
        id: 43,
        name: '二次元'
      },
      {
        id: 44,
        name: '人气热游'
      },
      {
        id: 45,
        name: '众多历史人物'
      },
      {
        id: 46,
        name: '像素风格'
      },
      {
        id: 47,
        name: '兵种搭配'
      },
      {
        id: 48,
        name: '复古巨作'
      },
      {
        id: 49,
        name: '娜扎推荐'
      },
      {
        id: 401,
        name: '娜扎来了'
      },
      {
        id: 402,
        name: '娜扎等你'
      },
      {
        id: 403,
        name: '实时战斗'
      },
      {
        id: 404,
        name: '开放地图'
      },
      {
        id: 405,
        name: '张国立推荐'
      },
      {
        id: 406,
        name: '张铁林推荐'
      },
      {
        id: 407,
        name: '征战天下'
      },
      {
        id: 408,
        name: '拟真写实'
      },
      {
        id: 409,
        name: '日韩卡通'
      },
      {
        id: 410,
        name: '日韩唯美'
      },
      {
        id: 411,
        name: '明亮风格'
      },
      {
        id: 412,
        name: '暗黑风格'
      },
      {
        id: 413,
        name: '杨幂力荐'
      },
      {
        id: 414,
        name: '热门职业'
      },
      {
        id: 415,
        name: '爆款新游'
      },
      {
        id: 416,
        name: '王刚推荐'
      },
      {
        id: 417,
        name: '精美国风'
      },
      {
        id: 418,
        name: '精美画风'
      },
      {
        id: 419,
        name: '经典复刻'
      },
      {
        id: 420,
        name: '经典复古'
      },
      {
        id: 421,
        name: '自由转职'
      },
      {
        id: 422,
        name: '萌燃战斗'
      },
      {
        id: 423,
        name: '西方魔幻'
      },
      {
        id: 424,
        name: '邓紫棋力荐'
      },
      {
        id: 425,
        name: '零门槛'
      },
      {
        id: 426,
        name: '高爆率'
      },
      {
        id: 427,
        name: '魔幻史诗'
      },
      {
        id: 428,
        name: '魔幻挂机'
      },
      {
        id: 429,
        name: '魔幻色彩'
      }
    ]
  },
  {
    id: 5,
    name: '游戏类型',
    children: [
      {
        id: 51,
        name: '休闲类'
      },
      {
        id: 52,
        name: '体育类'
      },
      {
        id: 53,
        name: '动作类'
      },
      {
        id: 54,
        name: '对战卡牌类'
      },
      {
        id: 55,
        name: '射击类'
      },
      {
        id: 56,
        name: '战争策略'
      },
      {
        id: 57,
        name: '模拟经营类'
      },
      {
        id: 58,
        name: '沙盒类'
      },
      {
        id: 59,
        name: '策略类'
      },
      {
        id: 501,
        name: '角色卡牌类'
      },
      {
        id: 502,
        name: '角色扮演类'
      },
      {
        id: 503,
        name: '音乐类'
      }
    ]
  },
  {
    id: 6,
    name: '游戏题材',
    children: [
      {
        id: 61,
        name: '三国'
      },
      {
        id: 62,
        name: '东方仙侠'
      },
      {
        id: 63,
        name: '东方历史'
      },
      {
        id: 64,
        name: '二次元'
      },
      {
        id: 65,
        name: '传奇'
      },
      {
        id: 66,
        name: '传奇回归'
      },
      {
        id: 67,
        name: '传奇回忆'
      },
      {
        id: 68,
        name: '体育运动'
      },
      {
        id: 69,
        name: '千人同屏'
      },
      {
        id: 601,
        name: '原始传奇'
      },
      {
        id: 602,
        name: '后宫'
      },
      {
        id: 603,
        name: '复古传奇'
      },
      {
        id: 604,
        name: '多题材融合'
      },
      {
        id: 605,
        name: '女性向'
      },
      {
        id: 606,
        name: '实时战斗'
      },
      {
        id: 607,
        name: '宫廷'
      },
      {
        id: 608,
        name: '日式鬼怪'
      },
      {
        id: 609,
        name: '末日生存'
      },
      {
        id: 610,
        name: '武侠'
      },
      {
        id: 611,
        name: '热血传奇'
      },
      {
        id: 612,
        name: '爆款新游'
      },
      {
        id: 613,
        name: '玄幻'
      },
      {
        id: 614,
        name: '现代其他'
      },
      {
        id: 615,
        name: '现代战争'
      },
      {
        id: 616,
        name: '现代都市'
      },
      {
        id: 617,
        name: '神话传说'
      },
      {
        id: 618,
        name: '科幻'
      },
      {
        id: 619,
        name: '联盟合作'
      },
      {
        id: 620,
        name: '自由战斗'
      },
      {
        id: 621,
        name: '航海'
      },
      {
        id: 622,
        name: '西方历史'
      },
      {
        id: 623,
        name: '西方魔幻'
      },
      {
        id: 624,
        name: '西游'
      },
      {
        id: 625,
        name: '音乐游戏'
      },
      {
        id: 626,
        name: '高策略手游'
      }
    ]
  },
  {
    id: 7,
    name: '行业地位',
    children: [
      {
        id: 71,
        name: '人气新游'
      },
      {
        id: 72,
        name: '今日公测'
      },
      {
        id: 73,
        name: '全新手游'
      },
      {
        id: 74,
        name: '官方授权'
      },
      {
        id: 75,
        name: '新游推荐'
      },
      {
        id: 76,
        name: '正版授权'
      },
      {
        id: 77,
        name: '热门新游'
      },
      {
        id: 78,
        name: '经典入门'
      },
      {
        id: 79,
        name: '经典巨作'
      }
    ]
  }
]
